import AppNavbar from "@/components/layout/AppNavbar";
import Footer from "@/components/layout/Footer";
import chatTokenStep1 from "@/assets/imgs/instructions/tokens/chat_token_1.png";
import chatTokenStep2 from "@/assets/imgs/instructions/tokens/chat_token_2.png";
import chatTokenStep3 from "@/assets/imgs/instructions/tokens/chat_token_3.png";
import chatTokenStep4 from "@/assets/imgs/instructions/tokens/chat_token_4.png";
import chatTokenStep5 from "@/assets/imgs/instructions/tokens/chat_token_5.png";
import chatTokenStep6 from "@/assets/imgs/instructions/tokens/chat_token_6.png";
import chatTokenStep7 from "@/assets/imgs/instructions/tokens/chat_token_7.png";
import chatTokenStep8 from "@/assets/imgs/instructions/tokens/chat_token_8.png";

import { Col } from "react-bootstrap";
// import 'bootstrap/dist/css/bootstrap.min.css';
import "@/assets/css/style.css";



function ChatToken() {

  return (
    <>
      <AppNavbar />
      <main className="container-lg nav-padding">
        <Col lg={{ span: 8, offset: 2 }} className="py-5">
          <h2 className="mb-4">Steps to Set Up a Chatbot</h2>
          <p>
            Favluv is designed so that you can connect an idol to an external
            chatbot or language model, so that you or other users can have a
            conversation with the idol.
          </p>
          <p>
            The following are the steps required to set it up. Please note, this
            is tested with the OpenAI API platform. But you should be able to use
            any LLM or custom chatbot.
          </p>
          <p>
            For the purpose of this document, please sign up to OpenAI API
            Platform and obtain an API Key, giving access to the OpenAI
            Conversations API.
          </p>
          <p className="mt-4">
            <strong>Step 1.</strong> Click on the <strong>Idol icon</strong> on the top right corner.
          </p>
          <img
            loading="lazy"
            src={chatTokenStep1}
            alt="Step 1: Open the Idol menu"
            className="img-fluid d-block rounded border mb-4"
          />
          <p className="mt-4">
            <strong>Step 2.</strong> Click <strong>User Settings</strong> button.
          </p>
          <img
            loading="lazy"
            src={chatTokenStep2}
            alt="Step 2: Open User Settings"
            className="img-fluid d-block rounded border mb-4"
          />
          <p className="mt-4">
            <strong>Step 3.</strong> Click on the <strong>Developer</strong> menu
            item, and then <strong>Token Management</strong> item.
          </p>
          <img
            loading="lazy"
            src={chatTokenStep3}
            alt="Step 3: Open Developer and Token Management"
            className="img-fluid d-block rounded border mb-4"
          />
          <p className="mt-4">
            <strong>Step 4.</strong> Select the Idol you would like to set up, and
            click <strong>Create Token</strong> button. On the right, you can also browse the chatbot webhook
            API documentation.
          </p>
          <img
            loading="lazy"
            src={chatTokenStep4}
            alt="Step 4: Select an idol and create a token"
            className="img-fluid d-block rounded border mb-4"
          />
          <p className="mt-4">
            <strong>Step 5.</strong> Enter token name for your management, and the lifespan of the
            token, and then press the <strong>Confirm</strong> button.
          </p>
          
          <p className="mt-4">
            <strong>Step 6.</strong> You will be given a string of text that is your Favluv token.
            Please copy it onto an external document for safe keeping. <strong>This text
            will only appear once.</strong>
          </p>
          <img
            loading="lazy"
            src={chatTokenStep5}
            alt="Step 6: Copy the generated Favluv token"
            className="img-fluid d-block rounded border mb-4"
          />
          
          <p className="mt-4">
            <strong>Step 7.</strong> Click on the <strong>Webhook Setting</strong> menu item on the left, and select
            your idol. Enter the webhook URL. The webhook is the middle ware that
            connects Favluv to the language model. We have a demo site at:
          </p>
          <p>
            <a href="https://openai.favluv.com/webhook">
              https://openai.favluv.com/webhook
            </a>
          </p>
          <img
            loading="lazy"
            src={chatTokenStep6}
            alt="Step 7: Select your idol on Webhook Setting"
            className="img-fluid d-block rounded border mb-4"
          />
          <img
            loading="lazy"
            src={chatTokenStep7}
            alt="Step 7: Enter the webhook URL and test the connection"
            className="img-fluid d-block rounded border mb-4"
          />
          <p>
            Click <strong>Test Connection</strong> to make sure that it is working correctly.
            Once tested, enter the <strong>Favluv Dev Token</strong> that you obtained on Step 6,
            and also the <strong>OpenAI Platform API key</strong>. You may select the event subscription
            checkboxes that you are interested in. Click <strong>Save</strong> and then you are
            done.
          </p>
          <img
            loading="lazy"
            src={chatTokenStep8}
            alt="Step 7: Configure tokens and event subscriptions, then save"
            className="img-fluid d-block rounded border mb-4"
          />
          <p className="mt-4 border-start border-primary border-3 ps-3">
            You can customize your Idol’s personality and quirks by using the <strong>AI
            Prompt</strong> field in the Idol’s profile. This field is only shown to you,
            the Idol owner, and is not shown to other users.
          </p>
        </Col>
      </main>
      <Footer />
    </>
  );
}

export default ChatToken;
